import { Go } from '@clearkit/icons';
import { CKButton } from 'clearkit';

import { HomeNextStep } from '../HomeNextStep';

export const StepAlertsWorkflow = () => (
  <HomeNextStep>
    <HomeNextStep.Heading>
      Build your first workflow: Get alerts when target accounts are on your
      website
    </HomeNextStep.Heading>
    <HomeNextStep.Description>
      Tell us about your target market and we'll do the rest.
    </HomeNextStep.Description>
    <HomeNextStep.Footer>
      {/**
       * @todo add URL
       * */}
      <CKButton
        href="/"
        rightIcon={<Go />}
        variant="simple"
        variantColor="blue"
      >
        Follow this guide
      </CKButton>
    </HomeNextStep.Footer>
  </HomeNextStep>
);
